export default __webpack_public_path__ + "static/media/ic_cases.c4409511.svg";